import { useEffect, useState } from 'react';
import { getAllActiveCompanySellersService } from '../services/company.service';

// Loads GetAllActiveCompanySellersAsync once and exposes both a flat CompanySeller
// option list (value === CompanySellerId) and the unique Company option list.
// Shared between the Partner Management filter and the User Request filter so
// the CS picker behaves the same everywhere.
export function useActiveCompanySellerOptions() {
    const [companyOptions, setCompanyOptions] = useState([]);
    const [sellerOptions, setSellerOptions] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const res = await getAllActiveCompanySellersService();
                if (cancelled) return;
                if (res?.data?.Status === 200 && Array.isArray(res.data.EntityList)) {
                    const list = res.data.EntityList;

                    const sellers = list.map(item => ({
                        id: item.CompanySellerId,
                        value: item.CompanySellerId,
                        label: `${item.CompanyName || ''}/${item.SellerName || ''}`,
                        companyId: item.CompanyId,
                        // Aliased so `computeAutoSelectedSellers` reads the seller's company.
                        companyIds: item.CompanyId,
                        companyName: item.CompanyName,
                        sellerId: item.SellerId,
                        sellerName: item.SellerName,
                        companySellerId: item.CompanySellerId,
                    }));

                    const seen = new Set();
                    const companies = [];
                    list.forEach(item => {
                        if (item.CompanyId != null && !seen.has(item.CompanyId)) {
                            seen.add(item.CompanyId);
                            companies.push({
                                Id: item.CompanyId,
                                value: item.CompanyId,
                                label: item.CompanyName,
                            });
                        }
                    });

                    setSellerOptions(sellers);
                    setCompanyOptions(companies);
                    setLoaded(true);
                }
            } catch {
                // Silently ignore — dropdowns just stay empty.
            }
        };
        load();
        return () => { cancelled = true; };
    }, []);

    return { companyOptions, sellerOptions, loaded };
}

export default useActiveCompanySellerOptions;
